export const facilityTypeTitles = {
  instacares: 'Instacares',
  emergencyRooms: 'Emergency Rooms',
  kidscares: 'Kids Cares'
};
